<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select v-model="query.state" style="width: 120px" size="small" clearable>
        <el-option value="未生成订单">未生成订单</el-option>
        <el-option value="已生成订单">已生成订单</el-option>
      </el-select>
      <el-input v-model="query.title" placeholder="标题" size="small" style="width:200px;" clearable />
      <el-input v-model="query.customer" placeholder="客户名称" size="small" style="width:200px;" clearable />
      <!-- <el-select-remote-ex
        v-model="query.fICItemID"
        size="small"
        placeholder="产品"
        url="ICItemManage/ICItem/ChoiceICItemEntry"
        label-field="fName"
        value-field="ficItemID"
      /> -->
      <el-select-table
        v-model="query.fICItemID"
        :label.sync="fName"
        url="ICItemManage/ICItem/ChoiceICItemEntry"
        label-field="fName"
        placeholder="产品"
        value-field="ficItemID"
        size="small"
        style="width:200px"
        panel-width="500px"
        :columns="[
          { prop: 'fNumber', label: '编码' },
          { prop: 'fName', label: '名称' },
          { prop: 'fModel', label: '规格' },
          { prop: 'fUnit', label: '单位' },
        ]"
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button type="primary" size="small" @click="_new">新增</el-button>
      <el-button-export
        :url="downloadUrl"
        type="primary"
        size="small"
        style="margin: 0 10px"
      >导入模版下载</el-button-export>

      <el-button type="warning" size="small" @click="_import">导入</el-button>
      <input
        ref="fileSel"
        type="file"
        style="display: none"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      >
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table v-loading="loading" v-el-table-height-fix :data="tableData" height="100%" @row-dblclick="_view">
        <el-table-column prop="title" label="标题" width="120" />
        <el-table-column prop="customer" label="客户" />
        <el-table-column prop="deliverType" label="发货方式" />
        <el-table-column prop="date" label="交货日期" width="100" />
        <el-table-column prop="state" label="状态" width="90" />
        <el-table-column prop="fNumber" label="产品编号" />
        <el-table-column prop="fName" label="产品名称" />
        <el-table-column prop="fModel" label="规格" />
        <el-table-column prop="fQty" label="数量" width="70" />
        <el-table-column label="操作" class-name="table-oper-col" width="85">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="_view(scope.row)">编辑</el-button>
            </template>
            <template>
              <ConfirmButton @confirm="_delete(scope.row)">删除</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'
import FileDownload from './FileDownload'

export default {
  components: {
    ConfirmButton,
    FileDownload
  },
  data() {
    return {
      query: {
        state: '未生成订单',
        title: null,
        customer: null,
        fICItemID: null,

        pageIndex: 1,
        pageSize: 20
      },
      fName: null,
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null
    }
  },
  // mounted() {
  //   this.refresh()
  // },
  activated() {
    this.refresh()
    // console.log('来了')
    // if (this.$route.query.isrefresh) this.refresh();
    // this.$route.query.isrefresh = null;
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('OrderManage/OrderTemporary/OrderTemporaryEntry', this.query).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.tableData = res.datalist.dataEntry
        this.pageRecordTotal = res.datalist.total
      })
        .finally(() => this.loading = false)
    },
    _new: function() {
      const url = this.$route.path + '/' + 0
      this.$router.push(url)
    },
    _view: function(row) {
      const url = this.$route.path + '/' + row.fid
      this.$router.push(url)
    },
    _delete: function(row) {
      this.loading = true
      this.$httpPost(`OrderManage/OrderTemporary/DeleteOrderTemporary`, { fid: row.fid }).then(res => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          this.loading = false
        }
      })
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'Download/OrderTemplateDownload',
        {}
      )
    },
    // 上传文件
    _import: function() {
      var fileSel = this.$refs.fileSel
      fileSel.onchange = () => {
        setTimeout(() => {
          fileSel.value = null
        }, 100)
        if (!fileSel.files.length) return
        var file = fileSel.files[0]
        this.$httpPostFile('Upload/OrderTemporaryUpload', file).then((res) => {
          if (!res.isSuccess) {
            if (res.returnCode == '00010') {
              const h = this.$createElement
              this.$formDlg({
                title: res.message,
                readonly: true,
                formTpl: <FileDownload url={res.datalist}></FileDownload>,
                formSubmit: (formData) =>
                  this.postData(formData)
              })
            } else {
              this.$message.error(res.message)
            }
          } else {
            this.$message.success(res.message)
            this.refresh()
          }
        })
      }
      fileSel.click()
    }
  }
}
</script>
